module.exports = __webpack_public_path__ + "static/media/land-scanner-banner-img.bb71aaab.jpg";